<div class="paneContentNoPadding">
	@if (!checklists?.length) {
		<sim-panel-content-warning-container
			[warningTitle]="T.CHECKLIST_PANEL_CONTENT_WARNING_TITLE | translate"
			[warningDescription]="T.CHECKLIST_PANEL_CONTENT_WARNING_DESCRIPTION | translate"
		/>
	}

	@if (checklists?.length) {
		<div class="checklistHolder h-100">
			<mat-tab-group color="accent" class="fullHeight h-100" [(selectedIndex)]="selectedTabIndex" [mat-stretch-tabs]="false">
				@for (checklist of checklists; track TrackByMethods.trackById(i, checklist); let i = $index) {
					<mat-tab [label]="checklist?.name">
						<div class="checklistItemHolder">
							@if (selectedTabIndex === i) {
								<sim-operator-checklist-panel
									[assessable]="checklist"
									[mode]="isInArchive ? AssessablePanelMode.View : AssessablePanelMode.Answer"
									[isInArchive]="isInArchive"
								/>
							}
						</div>
					</mat-tab>
				}
			</mat-tab-group>
		</div>
	}
</div>
